import InfoModalLegendItem from "./InfoModalLegendItem";
export default InfoModalLegendItem;
